{
	"filterError": "The fields array cannot have more than 4 items.",
	"perDay": "Per day",
	"byPeriod": "By period",
	"news": "News"
}
